import script from "./DelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DelModal.vue?vue&type=script&setup=true&lang=js"

import "./DelModal.vue?vue&type=style&index=0&id=3eb4acdc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb4acdc"]])

export default __exports__